module.exports = __webpack_public_path__ + "static/media/far-east.c9e6958a.svg";